// src/components/LienUtile.js
import React from "react";
import "../../CSS/LienUtile.css"; // Fichier CSS séparé
import icon_park_build from '../../images/icon_park_build.svg';
import OrganisationCountryBlock  from "../composant_reutilisable/Organisation_country";


function LienCooperation() {
  

  const organisationsData = [
    {
      country: "France",
      organisations: [
        {
          city: "Paris",
          organisation: "Organisation Mondiale de la Santé Animale (OIE)",
          href: "https://www.woah.org/fr/accueil/",
        },
        {
          city: "Paris",
          organisation: "Organisation Internationale de la Francophonie (OIF)",
          href: "https://www.francophonie.org",
        },
        {
          city: "Paris",
          organisation: "Organisation Internationale de Métrologie Légale (OIML)",
          href: "https://www.oiml.org/fr/front-page",
        },
        {
          city: "Paris",
          organisation: "Organisation des Nations Unies pour l'Education, la Science et la Culture (UNESCO)",
          href: "https://www.unesco.org/fr",
        },
        {
          city: "Paris",
          organisation: "Organisation pour la Coopération et le Développemnt Economiques (OCDE)",
          href: "https://www.oecd.org/fr.html",
        },
        
        {
          city: "Paris",
          organisation: "Bureau International des Expositions (BIE)",
          href: "https://www.bie-paris.org/site/fr/",
        },
        {
          city: "Paris",
          organisation: "Institut International du Froid (IIF)",
          href: "https://iifiir.org/fr",
        },
        {
          city: "Lyon",
          organisation: "Organisation Internationale de Police Criminelle (INTERPOL)",
          href: "https://www.interpol.int/fr",
        },
        
        {
          city: "Strasbourg",
          organisation: "Conseil de l'Europe (CE)/ Comité MEDICRIME",
          href: "https://www.coe.int/fr/web/medicrime",
        },
      ],
    },
    {
      country: "Belgique",
      organisations: [        
        {
          city: "La Haye",
          organisation: "Union Européenne (UE)",
          href: "https://european-union.europa.eu/index_fr",
        },
        {
          city: "Bruxelles",
          organisation: "Organisation des Etats d'Afrique, des Caraîbes et du Pacifique (OEACP)",
          href: "https://oacps-ri.eu/fr/",
        },
        {
          city: "Bruxelles",
          organisation: "Organisation Mondiale des Douanes (OMD)",
          href: "https://www.wcoomd.org/",
        },
        {
          city: "Bruxelles",
          organisation: "Organisation Internationale du Tourisme Social (OITS)",
          href: "https://isto.international/",
        },
      ],
    },
    {
      country: "Espagne",
      organisations: [        
        {
          city: "Madrid",
          organisation: "Organisation Mondiale du Tourisme (OMT)",
          href: "https://www.untourism.int/fr",
        }        
      ],
    },
    {
      country: "Pays Bas",
      organisations: [        
        {
          city: "La Haye",
          organisation: "Organisation Internationale des Armes Chimiques (OIAC)",
          href: "https://www.opcw.org/fr",
        },
        {
          city: "La Haye",
          organisation: "Cour Internationale de Justice (CIJ)",
          href: "https://www.icj-cij.org/fr/accueil",
        },
        {
          city: "La Haye",
          organisation: "Cour Pénale Internationale (CPI)",
          href: "https://www.icc-cpi.int/?ln=fr",
        },
        {
          city: "La Haye",
          organisation: "Cour Permanente d'Abritage (CPA)",
          href: "https://pca-cpa.org/fr/home/",
        },
      ],
    },
    {
      country: "Royaume Uni",
      organisations: [        
        {
          city: "Londres",
          organisation: "Organisation Internationale des Armes Chimiques (OIAC)",
          href: "https://www.opcw.org/fr",
        },
        {
          city: "Londres",
          organisation: "Organisation Internationale du Café (OIC)",
          href: "https://www.ico.org/fr/",
        }
      ],
    },
    {
      country: "Suisse",
      organisations: [
        {
          city: "Genève",
          organisation: "Organisation Internationale du Travail (OIT)",
          href: "https://www.ilo.org/",
        },
        {
          city: "Genève",
          organisation: "Organisation Mondiale du Commerce (OMC)",
          href: "https://www.wto.org/indexfr.htm",
        },
        {
          city: "Genève",
          organisation: "Organisation Mondiale de la Santé (OMS)",
          href: "https://www.who.int/fr",
        },
        {
          city: "Genève",
          organisation: "Conférence des Nations Unies sur le Commerce et le Développement (CNUCED)",
          href: "https://unctad.org/fr",
        }        
      ],
    },
    {
      country: "Autriche",
      organisations: [
        {
          city: "Vienne",
          organisation: "Agence Internationale de l'Energie Atomique (AIEA)",
          href: "https://www.iaea.org/fr",
        },
        {
          city: "Vienne",
          organisation: "Organisation des Nations Unies pour le Developpement Industriel (ONUDI)",
          href: "https://www.unido.org/",
        }
      ],
    },
  ];

  return (
     <div>
      {organisationsData.map((block, index) => (
        <OrganisationCountryBlock
          key={index}
          country={block.country}
          organisations={block.organisations}
        />
      ))}
    </div>
  );
}

export default LienCooperation;
